const endpoints = {
  "apiURL": "https://arsenal-middleware.herokuapp.com",
  "middlewareUrl" : "//arsenal-middleware.herokuapp.com",
  "managerUrl": "//manager.arsenalbarcelona.com/api/public/public",
  "literals": "literals",
  "screen": "screen"
}

export default endpoints